export enum KeycloakApplicationRolesEnum {
    PATIENT = 'PATIENT',
    DOCTOR = 'DOCTOR',
    CONTENTEDITOR = 'CONTENTEDITOR',
    ADMIN = 'ADMIN',
    USER = 'USER',
    SUPERADMIN = 'SUPERADMIN'
}
